const apiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
const enableEmailCaptureFlag = import.meta.env.VITE_ENABLE_EMAIL_CAPTURE as string | undefined;
const metaPixelId = import.meta.env.VITE_META_PIXEL_ID as string | undefined;
const metaDedupDebugFlag = import.meta.env.VITE_META_DEDUP_DEBUG as string | undefined;
const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined;
const polarTrialCheckoutUrl = import.meta.env.VITE_POLAR_TRIAL_CHECKOUT_URL as string | undefined;
const polarTrialStandardCheckoutUrl = import.meta.env.VITE_POLAR_TRIAL_STANDARD_CHECKOUT_URL as string | undefined;
const polarTrialProCheckoutUrl = import.meta.env.VITE_POLAR_TRIAL_PRO_CHECKOUT_URL as string | undefined;
const polarTrialProductId = import.meta.env.VITE_POLAR_TRIAL_PRODUCT_ID as string | undefined;
const polarTrialStandardProductId = import.meta.env.VITE_POLAR_TRIAL_STANDARD_PRODUCT_ID as string | undefined;
const polarTrialProProductId = import.meta.env.VITE_POLAR_TRIAL_PRO_PRODUCT_ID as string | undefined;
const polarTrialPriceDisplay = import.meta.env.VITE_POLAR_TRIAL_PRICE_DISPLAY as string | undefined;
const polarTrialPriceAmount = import.meta.env.VITE_POLAR_TRIAL_PRICE_AMOUNT as string | undefined;
const polarTrialCurrency = import.meta.env.VITE_POLAR_TRIAL_CURRENCY as string | undefined;
const polarTrialDays = import.meta.env.VITE_POLAR_TRIAL_DAYS as string | undefined;
const polarTrialRenewalCopy = import.meta.env.VITE_POLAR_TRIAL_RENEWAL_COPY as string | undefined;
const polarTrialStandardRenewalDisplay = import.meta.env.VITE_POLAR_TRIAL_STANDARD_RENEWAL_DISPLAY as string | undefined;
const polarTrialProRenewalDisplay = import.meta.env.VITE_POLAR_TRIAL_PRO_RENEWAL_DISPLAY as string | undefined;

const parseBooleanFlag = (value: string | undefined, fallback: boolean): boolean => {
  if (!value) return fallback;
  const normalized = value.trim().toLowerCase();
  if (normalized === "true") return true;
  if (normalized === "false") return false;
  return fallback;
};

export const config = {
  apiBaseUrl: apiBaseUrl?.replace(/\/$/, "") ?? "",
  supabaseUrl: supabaseUrl ?? "",
  supabaseAnonKey: supabaseAnonKey ?? "",
  enableEmailCapture: parseBooleanFlag(enableEmailCaptureFlag, true),
  metaPixelId: metaPixelId?.trim() ?? "",
  metaDedupDebug: parseBooleanFlag(metaDedupDebugFlag, false),
  posthogKey: posthogKey?.trim() ?? "",
  posthogHost: posthogHost?.trim() || "https://us.i.posthog.com",
  polarTrialCheckoutUrl: polarTrialCheckoutUrl?.trim() ?? "",
  polarTrialStandardCheckoutUrl: polarTrialStandardCheckoutUrl?.trim() ?? "",
  polarTrialProCheckoutUrl: polarTrialProCheckoutUrl?.trim() ?? "",
  polarTrialProductId: polarTrialProductId?.trim() ?? "",
  polarTrialStandardProductId: polarTrialStandardProductId?.trim() ?? "",
  polarTrialProProductId: polarTrialProProductId?.trim() ?? "",
  polarTrialPriceDisplay: polarTrialPriceDisplay?.trim() || "Free",
  polarTrialPriceAmount: polarTrialPriceAmount?.trim() || "0",
  polarTrialCurrency: polarTrialCurrency?.trim() || "AUD",
  polarTrialDays: polarTrialDays?.trim() || "7",
  polarTrialRenewalCopy: polarTrialRenewalCopy?.trim() || "Then the subscription renews automatically unless canceled.",
  polarTrialStandardRenewalDisplay: polarTrialStandardRenewalDisplay?.trim() || "AU$29/year",
  polarTrialProRenewalDisplay: polarTrialProRenewalDisplay?.trim() || "AU$39/year"
} as const;

export const brand = {
  name: "Linkhiv",
  logoPath: "/assets/logo-clean-172w.webp",
  iconPath: "/assets/icon-clean.webp",
  heroGraphicPath: "/assets/hero-graphic.webp",
  privacyPolicyUrl: "https://linkhiv.com/privacy",
  termsUrl: "https://linkhiv.com/terms",
  macosMinimumVersion: "macOS 14+"
} as const;
